import { useMemo } from 'react'

import { type ApplicationFrameProps } from '@factorialco/f0-react/dist/experimental'
import { Lightbulb, People, Timer } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export const useWelcomeScreenSuggestions = (): NonNullable<
  ApplicationFrameProps['ai']
>['welcomeScreenSuggestions'] => {
  return useMemo(() => {
    return [
      {
        icon: Lightbulb,
        message: i18n.t('common.ai.welcome_screen_suggestions.general_1'),
      },
      {
        icon: Lightbulb,
        message: i18n.t('common.ai.welcome_screen_suggestions.general_2'),
      },
      {
        icon: Timer,
        message: i18n.t('common.ai.welcome_screen_suggestions.timeoff_1'),
      },
      {
        icon: Timer,
        message: i18n.t('common.ai.welcome_screen_suggestions.timeoff_2'),
      },
      {
        icon: Timer,
        message: i18n.t('common.ai.welcome_screen_suggestions.timeoff_3'),
      },
      {
        icon: Timer,
        message: i18n.t('common.ai.welcome_screen_suggestions.timeoff_4'),
      },
      {
        icon: People,
        message: i18n.t('common.ai.welcome_screen_suggestions.org_1'),
      },
      {
        icon: People,
        message: i18n.t('common.ai.welcome_screen_suggestions.org_2'),
      },
      {
        icon: People,
        message: i18n.t('common.ai.welcome_screen_suggestions.org_3'),
      },
      {
        icon: People,
        message: i18n.t('common.ai.welcome_screen_suggestions.org_4'),
      },
      {
        icon: People,
        message: i18n.t('common.ai.welcome_screen_suggestions.org_5'),
      },
      {
        icon: People,
        message: i18n.t('common.ai.welcome_screen_suggestions.org_6'),
      },
    ]
  }, [])
}
